import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AlertTriangle, Clock, ShieldAlert } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const feeColor = (fee) => {
  if (fee === 0) return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300';
  if (fee <= 50) return 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300';
  if (fee <= 100) return 'bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300';
  return 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300';
};

const CancellationPolicyCard = () => {
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/api/cancellation-policy`)
      .then((res) => setPolicy(res.data))
      .catch(() => setPolicy(null));
  }, []);

  if (!policy) return null;

  return (
    <div
      data-testid="cancellation-policy-card"
      className="rounded-2xl border-2 border-amber-400 dark:border-amber-700 bg-amber-50/80 dark:bg-amber-950/30 overflow-hidden shadow-md"
    >
      {/* Header — always visible, prominent */}
      <div
        data-testid="cancellation-policy-toggle"
        className="flex items-center gap-2 px-5 py-4 bg-amber-100/80 dark:bg-amber-900/30 border-b-2 border-amber-300 dark:border-amber-800"
      >
        <AlertTriangle className="w-7 h-7 text-amber-600 shrink-0" />
        <h3 className="font-extrabold text-amber-900 dark:text-amber-200 text-xl md:text-2xl">
          מדיניות ביטולים ודמי ביטול
        </h3>
      </div>

      <div className="px-5 py-4 space-y-3">
        <p className="text-base font-semibold text-amber-800 dark:text-amber-300 flex items-center gap-2">
          <Clock className="w-5 h-5" />
          דמי הביטול נקבעים לפי הזמן שנותר עד תחילת התחרות:
        </p>
        <div className="space-y-2.5">
          {policy.tiers?.map((tier, idx) => (
            <div
              key={idx}
              data-testid={`policy-tier-${idx}`}
              className="flex items-center justify-between gap-3 bg-white dark:bg-gray-900/50 rounded-xl px-4 py-3.5 border-2 border-amber-100 dark:border-amber-900/40"
            >
              <span className="text-base md:text-lg font-medium text-gray-800 dark:text-gray-200">{tier.label}</span>
              <span className={`text-base md:text-lg font-extrabold px-4 py-1.5 rounded-full whitespace-nowrap ${feeColor(tier.fee)}`}>
                {tier.fee === 0 ? 'חינם' : `${tier.fee}${policy.currency}`}
              </span>
            </div>
          ))}
        </div>
        {policy.suspension_note && (
          <div className="flex items-start gap-2 text-sm md:text-base font-semibold text-red-700 dark:text-red-400 bg-red-50 dark:bg-red-950/30 rounded-xl px-4 py-3 border-2 border-red-300 dark:border-red-900/50">
            <ShieldAlert className="w-6 h-6 shrink-0 mt-0.5" />
            <span>{policy.suspension_note}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CancellationPolicyCard;
